import { Outlet } from 'react-router-dom'

import DashboardNavbar from './DashboardNavbar'

import './dashboard.css'
import BufferPage from 'components/pages/BufferPage'
import { useSelector } from 'react-redux'
import { selectRole } from 'routing/fetchingfunction/user/user.reducer'

const DashboardLayout = () => {
  const role = useSelector(selectRole)

  return (
    <div className="pt-[10px] pb-[32px]">
      <div className="wrapper">
        {/* <div>
          <BufferPage role={role} />
        </div> */}

        <div>
          <nav aria-label="Dashboard">
            <DashboardNavbar />
          </nav>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout
